module.exports = __webpack_public_path__ + "static/media/02-landing-page.b18d0669.png";